import { z } from 'zod';
import { businessErrorCodeSchema } from './business-error-code.js';
import { REQUEST_INVALID_CODE, } from './request-invalid.js';
export const paginationSchema = z.object({
    page: z.number(),
    size: z.number(),
    totalCount: z.number(),
});
export const metaSchema = z.object({
    pagination: paginationSchema.optional(),
    debug: z.unknown().optional(),
});
/** 에러 body의 `code`. 비즈니스 코드이거나 요청 계약 코드다. */
export const errorCodeSchema = z.union([
    z.literal(REQUEST_INVALID_CODE),
    businessErrorCodeSchema,
]);
/** 요청 계약 실패의 필드 힌트. flatten dump 키는 받지 않는다. */
const requestInvalidIssueSchema = z.object({
    path: z.array(z.union([z.string(), z.number()])),
    code: z.string(),
    message: z.string().optional(),
});
/**
 * 비즈니스 오류 또는 요청 계약 실패 body.
 * 사람 문구는 넣지 않고, 코드가 필요로 하는 사실·필드 힌트만 추가한다.
 */
export const errorBodySchema = z
    .object({
    code: errorCodeSchema.optional(),
    issues: z.array(requestInvalidIssueSchema).optional(),
    debug: z.unknown().optional(),
    resendAvailableAt: z.string().optional(),
    expiresAt: z.string().optional(),
})
    .passthrough();
export function requiredPayloadEnvelope(payload) {
    return z.object({
        payload,
        meta: metaSchema.optional(),
    });
}
export function payloadEnvelope(payload) {
    return z.object({
        payload: payload.optional(),
        meta: metaSchema.optional(),
    });
}
export const emptyEnvelopeSchema = z.object({
    meta: metaSchema.optional(),
});
export const commonErrorResponses = {
    400: errorBodySchema,
    401: errorBodySchema,
    403: errorBodySchema,
    404: errorBodySchema,
    409: errorBodySchema,
    429: errorBodySchema,
    500: errorBodySchema,
};
//# sourceMappingURL=envelope.js.map